/**
 * Defines when the discount code is applied.
 *
 * Either we apply the discount ahead of time on a pre-defined cart
 * or after the user has populated the cart at checkout.
 *
 * - PredefinedCart: The discount will be applied immediately on a pre-defined cart populated with the products
 *                   that the discount code is targeting. This is done on the Secret Page.
 *
 * - CheckoutCode:   A User Defined Cart, where the discount will be applied on the products that user has selected.
 *                   This is done on the Payment Page, a.k.a checkout.
 */
export var CartDiscountType = /*#__PURE__*/function (CartDiscountType) {
  CartDiscountType["PredefinedCart"] = "PredefinedCart";
  CartDiscountType["CheckoutCode"] = "CheckoutCode";
  return CartDiscountType;
}(CartDiscountType || {});
export var CartDiscountStatus = /*#__PURE__*/function (CartDiscountStatus) {
  CartDiscountStatus["Mismatch"] = "Mismatch";
  CartDiscountStatus["Applied"] = "Applied";
  CartDiscountStatus["None"] = "None";
  return CartDiscountStatus;
}(CartDiscountStatus || {});